// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import store from './store'
import VueCookies from 'vue-cookies'
import i18n from './translate'
import VueAxios from 'vue-axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueAnalytics from 'vue-analytics'

window.Vue = require('vue')
Vue.use(VueAnalytics, {
  id: 'G-PELZ5J5X84'
})

Vue.use(VueAxios, axios, VueI18n, router, store, VueCookies)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$host = 'https://nkcreative.hu/api/v1/'
Vue.prototype.$translate = i18n
Vue.prototype.$eventHub = new Vue()
require('./axiox/axios-interceptor')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  VueAxios,
  axios,
  VueCookies,
  store,
  i18n,
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js